import { isAddrMatch, sortByRank, splitAddr } from "./address";
import { buildKubunsMap, resolveChiikiName } from "./kubuns";
import { normalizeValue } from "./utils";

export function createChiikiContext(chiikiRows, keikaRows) {
  const kubunsCache = new Map();

  const getKubunsMap = (law, date, keikasochi = false) => {
    const key = `${law}|${date}|${keikasochi}`;
    if (!kubunsCache.has(key)) {
      kubunsCache.set(key, buildKubunsMap(chiikiRows, keikaRows, law, date, keikasochi));
    }
    return kubunsCache.get(key);
  };

  return {
    getChiikiByAddr({ law, date, addr, keikasochi = false }) {
      const [todoufuken, city] = splitAddr(addr);
      const filtered = chiikiRows
        .filter((row) => isAddrMatch(todoufuken, city, row))
        .sort(sortByRank);
      return resolveChiikiName(chiikiRows, keikaRows, law, date, keikasochi, filtered);
    },

    getChiikiCode({ law, date, chiiki, keikasochi = false }) {
      const map = getKubunsMap(law, date, keikasochi);
      const target = normalizeValue(chiiki);
      for (const [code, name] of map.entries()) {
        if (name === target) {
          return code;
        }
      }
      return null;
    },
  };
}
